var React = require('react');

function PaginationLeftDouble (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M436.61-221.91 178.52-480l258.09-258.09L510.7-664 327.13-480 510.7-296l-74.09 74.09Zm270.78 0L449.3-480l258.09-258.09L781.48-664l-183 184 183 184-74.09 74.09Z"}));
}

PaginationLeftDouble.defaultProps = {"height":"24","viewBox":"0 -960 960 960","width":"24"};

module.exports = PaginationLeftDouble;

PaginationLeftDouble.default = PaginationLeftDouble;
